import {useRepositories} from "@web-libs/core/repositories/application/repository-concerns";
import {useEffect, useState} from "react";
import {AppointmentCategory, Specialization} from "@web-libs/features/appointments/domain/appointment.types";
import {useRessourceState} from "@web-libs/core/ressources/use-ressource-state";
import {useRessource} from "@web-libs/core/ressources/use-ressource";
import {useParams} from "next/navigation";
import {routes} from "@web-app/[lang]/[tenant]/[institution]/routes-institution";
import {useTageaRouter} from "@web-libs/core/routing/application/use-tagea-router.concern";

export const useBookingSearch = () => {
    const {getRepo} = useRepositories()
    const specializationRepo = getRepo('SpecializationRepository')
    const categoryRepo = getRepo('AppointmentCategoryRepository')
    const [specializations, setSpecializations] = useState<Specialization[]>([])
    const [currentSpecialization, setCurrentSpecialization] = useState<Specialization>()
    const [categories, setCategories] = useState<AppointmentCategory[]>([])
    const {
        isLoading: isLoadingSpecializations,
        setIsLoading: setIsLoadingSpecializations,
        error: specializationError,
        setError: setSpecializationError
    } = useRessourceState()

    const params = useParams()
    const router = useTageaRouter()

    const {
        fetchRessource: _fetchCategories,
        isLoading: isLoadingCategories,
        error: categoryError,
    } = useRessource<AppointmentCategory[]>()

    const fetchSpecializations = async () => {
        setIsLoadingSpecializations(true);
        try {
            const data = await specializationRepo.getSpecializations([params.institution.toString()]);
            setSpecializations(data);
            setCurrentSpecialization(data[0])
            // if(data.length == 0) openNoCategorySelection()
        } catch {
            setSpecializationError("Beim Laden der verfügbaren Termine ist ein Fehler aufgetreten.");
        } finally {
            setIsLoadingSpecializations(false);
        }
    }

    useEffect(() => {
        fetchSpecializations()
    }, [])

    const fetchCategories = async () => {
        const fetch = () => categoryRepo.getCategories(params.institution.toString(),
             currentSpecialization?.id
        )
           await _fetchCategories(
               fetch,
               (data) => setCategories(data),
               "Beim Laden der verfügbaren Termine ist ein Fehler aufgetreten."
           )
    }

    const openNoCategorySelection = () => {
        router.push(routes.appointmentBookingCategory("allCategories"))
    }

    useEffect(() => {
        fetchCategories();
    }, [currentSpecialization]);

    return {
        specializations,
        categories,
        currentSpecialization,
        setCurrentSpecialization,
        isLoadingSpecializations,
        isLoadingCategories,
        specializationError,
        categoryError,
        openNoCategorySelection
    }
}
